type UtmTrackingReason = 'LAST_TOUCH_REGISTRATION_ATTRIBUTION';
const UTM_PARAMS_STORAGE_KEYS: Record<UtmTrackingReason, string> = {
  LAST_TOUCH_REGISTRATION_ATTRIBUTION:
    'utm-params/last-touch-registration-attribution',
};

type RequiredUtmParams = 'utm_source' | 'utm_medium' | 'utm_campaign';
type OptionalUtmParams = 'utm_term' | 'utm_content';
type UtmParams = RequiredUtmParams | OptionalUtmParams;

type AllUtmParams = { [key in RequiredUtmParams]: string } &
  { [key in OptionalUtmParams]?: string };

const allUtmParams: UtmParams[] = [
  'utm_campaign',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_term',
];

export const storeUtmParams = (reason: UtmTrackingReason) => {
  const allSearchParams = new URL(window.location.href).searchParams;
  const resolvedUtmParams: Partial<Record<UtmParams, string>> = {};

  for (const param of allUtmParams) {
    if (allSearchParams.has(param)) {
      resolvedUtmParams[param] = allSearchParams.get(param) ?? undefined;
    }
  }

  if (Object.keys(resolvedUtmParams).length > 0) {
    // Note that this uses session storage. Saved utm data should be ephemeral.
    sessionStorage.setItem(
      UTM_PARAMS_STORAGE_KEYS[reason],
      JSON.stringify(resolvedUtmParams)
    );
  }
};

export const fetchStoredUtmParams = (reason: UtmTrackingReason) => {
  const storedData = sessionStorage.getItem(UTM_PARAMS_STORAGE_KEYS[reason]);

  return storedData ? (JSON.parse(storedData) as AllUtmParams) : undefined;
};
